module.exports = __webpack_public_path__ + "img/background.a688423d.jpg";